/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useState, useEffect, createContext } from 'react';

import api from '../utils/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('@ecomLoversAdmin:token');
    const userStorage = localStorage.getItem('@ecomLoversAdmin:user');

    if (userStorage && token) {
      setUserData(JSON.parse(userStorage));
    }
    if (token) {
      api.defaults.headers.Authorization = `Bearer ${token}`;
    }

    setLoading(false);
  }, []);

  const signIn = async ({ email, password }) => {
    setLoading(true);

    try {
      const { data } = await api.post('/admins/authenticate', {
        email: email.trim(),
        password,
      });

      const parsedUser = {
        id: data.data.id,
        ...data.data.attributes,
      };

      localStorage.setItem('@ecomLoversAdmin: user', JSON.stringify(parsedUser));
      localStorage.setItem('@ecomLoversAdmin: token', parsedUser.authToken);

      api.defaults.headers.Authorization = `Bearer ${parsedUser.authToken}`;

      setUserData(parsedUser);
    } catch (error) {
      // console.log(error);

      if (error?.response?.data?.error?.admin_authentication) {
        alert('Invalid email or password. Please try again.');
      } else if (error?.response?.data?.errors && error?.response?.data?.errors[0]?.title) {
        alert(`${error.response.data.errors[0].title}`);
      } else {
        alert('Something unexpected happened. Please try again.');
      }
    }
    setLoading(false);
  };

  const signOut = async () => {
    localStorage.removeItem('@ecomLoversAdmin: user');
    api.defaults.headers.Authorization = undefined;

    setUserData(null);
  };

  const signOutIfTokenExpired = async () => {
    const user = localStorage.getItem('@ecomLoversAdmin: user');
    if (user) {
      const parsedUser = JSON.parse(user);

      if (moment(parsedUser.expiresAt).isBefore(new Date())) {
        signOut();
      } else {
        api.defaults.headers.Authorization = `Bearer ${parsedUser.authToken}`;
        setUserData(parsedUser);
      }
    } else {
      signOut();
    }
  };

  useEffect(() => {
    signOutIfTokenExpired();
  }, []);

  return (
    <AuthContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        user: userData,
        loading,
        signIn,
        signOut,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node,
};
